import React from "react";
import Cookies from 'universal-cookie';

// components
import PageTitle from "../components/PageTitle/PageTitle";
import LoadingButton from '@mui/lab/LoadingButton';
import MultipleSelect from "../widgets/MultiSelect";
import { styled } from '@mui/material/styles';
import { Typography } from "@material-ui/core";
import { FormControl, FormControlLabel, InputLabel } from "@mui/material";
import Switch from '@mui/material/Switch';
import { InputAdornment, MenuItem, Select, Stack, TextField } from "@mui/material";
import SettingsTitle from "../widgets/SettingsTitle";
import ManageRowSettings from "../widgets/ManageRowSettings";
import _default from "../themes/default";

// apis
import getFunzionari from "../services/getFunzionari";
import getClienti from "../services/getClienti";
import getAgenti from "../services/getAgenti";
import getProdotti from "../services/getProdotti";
import addOrdine from "../services/addOrdine";
import getCliente from "../services/getCliente";
import moment from "moment";
import addReminder from "../services/addReminder";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
let userType = cookies.get('userType', { path: '/' });

const rowTitle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 4,
    borderBottom: '0.3px solid #c1c1c1',
    marginTop: 30,
    marginBottom: 20
}

const groupInput = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 5,
}

const inputStyle = {
    borderRadius: 4,
    width: '80%',
    paddingTop: 9,
    paddingBottom: 9,
    paddingInline: 9,
    outlineColor: '#4A4A4A',
    outlineWidth: "thin"
}

const smallInputStyle = {
    borderRadius: 4,
    width: '45%',
    marginLeft: 5,
    paddingTop: 9,
    paddingBottom: 9,
    paddingInline: 9,
    outlineColor: '#4A4A4A',
    outlineWidth: "thin"
}

const Android12Switch = styled(Switch)(({ theme }) => ({
    margin: 8,
    padding: 8,
    '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        '&:before, &:after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
        },
        '&:before': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
        },
        '&:after': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            right: 12,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
    },
})
);

export default class AddOrdine extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            agenti: [],
            clienti: [],
            prodotti: [],
            funzionari: [],
            tecnico: false,
            is_preventivo: 0,
            agente: '',
            segnalatore: '',
            funzionario: '',
            legato_cliente: true,
            legacy_fatturazione: [],
            legacy_incasso: [],
            legacy_provvigioni: [],
            legacy_provvigioniSegnalatore: [],
            fatturazione: [],
            incasso: [],
            provvigioni: [],
            provvigioniSegnalatore: [],
            fatPerc: 0,
            incPerc: 0,
            gru: false,
            autotreno: false,
            userType: userType,
            indirizzo: '',
            rif: '',
        };
    }

    async componentDidMount() {
        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });
        userType = cookies.get('userType', { path: '/' });

        let prodottiList = await getProdotti(username, token);
        this.baseProdotti = prodottiList;

        let res = null
        await getClienti(username, token).then((response) => {
            res = response;
        });
        res.forEach((c, i) => {
            res[i].label = c.ragione_sociale
        })

        let agenti = await getAgenti(username, token);
        agenti.forEach((agente) => agente['label'] = agente.ragione_sociale)
        const is_preventivo = this.props.history.location.state?.is_preventivo ? 1 : 0;
        this.setState({ clienti: res, prodottiList, agenti, userType: userType, is_preventivo: is_preventivo });

        let funzionari = await getFunzionari(username, token);
        funzionari.forEach((funzionario) => funzionario['label'] = funzionario.nome + ' ' + funzionario.cognome)
        this.setState({ funzionari });
    }
    
    async loadCliente(id) {
        let cliente_selezionato = this.state.clienti.find(c => c.id === id[0]);
        this.setState({
            fatturazione: cliente_selezionato.fatturazione ? JSON.parse(cliente_selezionato.fatturazione) : [],
            incasso: cliente_selezionato.pagamento ? JSON.parse(cliente_selezionato.pagamento) : [],
            provvigioni: cliente_selezionato.provvigioni ? JSON.parse(cliente_selezionato.provvigioni) : [],
            provvigioniSegnalatore: cliente_selezionato.segnalatore ? JSON.parse(cliente_selezionato.segnalatore) : [],
            legacy_fatturazione: cliente_selezionato.fatturazione ? JSON.parse(cliente_selezionato.fatturazione) : [],
            legacy_incasso: cliente_selezionato.pagamento ? JSON.parse(cliente_selezionato.pagamento) : [],
            legacy_provvigioni: cliente_selezionato.provvigioni ? JSON.parse(cliente_selezionato.provvigioni) : [],
            legacy_provvigioniSegnalatore: cliente_selezionato.segnalatore ? JSON.parse(cliente_selezionato.segnalatore) : [],
        })
        this.setState(() => ({ cliente: null, prodotti: [] }), async () => {
            this.calcolaTotale();
            let cliente = await getCliente(username, token, id);
            let prodotti = await getProdotti(username, token);
            let prodottiCliente = cliente.prodotti_custom ? JSON.parse(cliente.prodotti_custom) : [];
            prodotti.forEach((p, i) => {
                let nuovoCosto = prodottiCliente.find(prodotto => prodotto.prodottoId === p.id);
                if (nuovoCosto)
                    prodotti[i].prezzo = nuovoCosto.price;
            });

            this.setState({ cliente: id, prodottiList: prodotti });
        });
    }

    addInput(param) {
        let obj = { id_prodotto: null, label: '', prezzo: '', quantita: null }
        let new_array = [...this.state[param], obj]
        this.setState({ [param]: new_array })
    }

    addInputPagamenti(type) {
        let obj = { percentage: 0, days: '', from: 'DO' }
        let arr = this.state[type];
        arr.push(obj);
        this.setState({ [type]: arr }, () => this.updatePercentage());
    }

    calcolaTotale() {
        let totale = 0;
        this.state.prodotti.forEach((prodotto) => {
            totale += (parseFloat(prodotto.prezzo) * parseInt(prodotto.quantita));
        })
        if (this.state.tecnico) {
            totale += parseFloat(this.state.costoTecnico);
        }
        this.setState({ totale: totale.toFixed(2) })
    }

    updatePercentage() {
        let fatPerc = 0;
        let incPerc = 0;
        this.state.fatturazione.forEach((fatturazione) => {
            fatPerc += parseInt(fatturazione.percentage);
        })
        this.state.incasso.forEach((incasso) => {
            incPerc += parseInt(incasso.percentage);
        })
        this.setState({ fatPerc, incPerc });
    }

    render() {
        return (
            <>
                <PageTitle title={'Nuovo documento commerciale'} />

                <Stack spacing={3}>
                    <Stack spacing={3} sx={{ flex: 1 }} direction={'row'}>
                        {/* CLIENTI */}
                        <MultipleSelect grow label={'Cliente'} oneSelected names={this.state.clienti} single onChangeListener={(cliente) => this.loadCliente(cliente)} sel={this.state.cliente} />
                        <TextField
                            sx={{ flexGrow: 1 }}
                            value={this.state.rif}
                            onChange={(e) => {
                                this.setState({ rif: e.target.value })
                            }}
                            label="Riferimento"
                        />
                        {/* REGOLE CLIENTE */}
                        <FormControlLabel
                            sx={{ marginTop: '5px !important' }} disabled={!this.state.cliente}
                            control={<Android12Switch checked={this.state.legato_cliente}
                                onChange={() => {
                                    this.setState({ legato_cliente: !this.state.legato_cliente }, () => {
                                        if (this.state.legato_cliente) {
                                            this.setState({
                                                fatturazione: this.state.legacy_fatturazione,
                                                incasso: this.state.legacy_incasso,
                                                provvigioni: this.state.legacy_provvigioni,
                                                provvigioniSegnalatore: this.state.legacy_provvigioniSegnalatore,
                                            })
                                        }
                                    })
                                    this.updatePercentage()
                                }}
                            />}
                            label="Mantieni regole del cliente"
                        />
                    </Stack>
                    {/* DESCRIZIONE */}
                    <TextField fullWidth multiline rows={4} variant="outlined" label={'Descrizione'} value={this.state.descrizione}
                        onChange={(e) => { this.setState({ descrizione: e.target.value }) }
                        } />
                </Stack>

                <Stack spacing={3} sx={{ flex: 1, marginTop: 5 }} direction={'row'}>
                    {/* AGENTE */}
                    <FormControl sx={{ flexGrow: 1 }}>
                        <InputLabel>Agente</InputLabel>
                        <Select label="Agente"
                            value={this.state.agente}
                            onChange={(e) => {
                                this.setState({ agente: e.target.value })
                            }}
                        >
                            <MenuItem value={'Nessun agente'}>Nessun agente</MenuItem>
                            {
                                this.state.agenti.map((agente, i) => {
                                    return (
                                        <MenuItem key={i} value={agente.id}>{agente.ragione_sociale}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    {/* SEGNALATORE */}
                    <FormControl sx={{ flexGrow: 1 }}>
                        <InputLabel>Segnalatore</InputLabel>
                        <Select label="Segnalatore"
                            value={this.state.segnalatore}
                            onChange={(e) => {
                                this.setState({ segnalatore: e.target.value })
                            }}
                        >
                            <MenuItem value={'Nessun segnalatore'}>Nessun segnalatore</MenuItem>
                            {
                                this.state.agenti.map((segnalatore, i) => {
                                    return (
                                        <MenuItem key={i} value={segnalatore.id}>{segnalatore.ragione_sociale}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    {/* FUNZIONARIO */}
                    <FormControl sx={{ flexGrow: 1 }}>
                        <InputLabel>Funzionario</InputLabel>
                        <Select label="Funzionario"
                            value={this.state.funzionario}
                            onChange={(e) => {
                                this.setState({ funzionario: e.target.value })
                            }}
                        >
                            <MenuItem value={'Nessun funzionario'}>Nessun funzionario</MenuItem>
                            {
                                this.state.funzionari.map((funzionario, i) => {
                                    return (
                                        <MenuItem key={i} value={funzionario.id}>{funzionario.nome + ' ' + funzionario.cognome}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                </Stack>

                {/* RIFERIMENTO CANTIERE */}
                <Stack spacing={3} sx={{ flex: 1, marginTop: 5 }}>
                    <TextField fullWidth variant="outlined" label={'Riferimento cantiere'} value={this.state.riferimento_cantiere} onChange={(e) => { this.setState({ riferimento_cantiere: e.target.value }) }} />
                    <TextField InputProps={{ readOnly: this.state.userType !== '3' }} InputLabelProps={{ shrink: this.state.indirizzo }} fullWidth variant="outlined" label={'Indirizzo cantiere'} value={this.state.indirizzo} onChange={(e) => { this.setState({ indirizzo: e.target.value }) }} />
                </Stack>

                {this.state.cliente && (
                    <>
                        <Stack spacing={3} sx={{ flex: 1 }}>
                            {/* ADD PRODOTTI */}
                            <div style={rowTitle}>
                                <SettingsTitle title="Prodotti" />
                                <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInput('prodotti')} />
                            </div>
                            <div>
                                {
                                    this.state.prodotti.map((el, i) => {
                                        return (
                                            <div key={i} style={groupInput}>
                                                <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} alignItems={'center'} >

                                                    {/* SELECT PRODOTTI */}
                                                    <TextField
                                                        sx={{ flexGrow: 1 }}
                                                        select
                                                        value={el.label}
                                                        label="Prodotto"
                                                        onChange={(e) => {
                                                            let arr = [...this.state.prodotti]
                                                            arr[i].label = e.target.value;
                                                            arr[i].prezzo = this.state.prodottiList.find((n) => n.nome === e.target.value).prezzo;
                                                            arr[i].id_prodotto = this.state.prodottiList.find((n) => n.nome === e.target.value).id;
                                                            arr[i].quantita = 1;
                                                            this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                        }}
                                                    >
                                                        {
                                                            this.state.prodottiList.map((prodotto, i) => {
                                                                return (
                                                                    <MenuItem key={i} value={prodotto.nome}>{prodotto.nome}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </TextField>

                                                    {/* QUANTITA */}
                                                    <TextField
                                                        InputLabelProps={{ shrink: el.quantita }}
                                                        type="number"
                                                        variant="outlined"
                                                        label={'Quantita'} value={el.quantita}
                                                        onChange={(e) => {
                                                            let arr = this.state.prodotti
                                                            arr[i].quantita = e.target.value
                                                            this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                        }} />


                                                    {/* PREZZO UNITARIO */}
                                                    <TextField
                                                        InputProps={{ endAdornment: <InputAdornment position="end">€</InputAdornment>, }}
                                                        type="number"
                                                        variant="outlined"
                                                        label={'Prezzo Unità'} value={el.prezzo}
                                                        onChange={(e) => {
                                                            let arr = this.state.prodotti
                                                            arr[i].prezzo = e.target.value
                                                            this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                        }} />

                                                    {/* DELETE PRODOTTO ROW */}
                                                    <ManageRowSettings
                                                        callback={() => {
                                                            let updated = this.state.prodotti.filter((e, index) => index !== i)
                                                            this.setState(() => ({ prodotti: updated }), () => {
                                                                this.calcolaTotale();
                                                            })
                                                        }}
                                                    />
                                                </Stack>
                                            </div>
                                        )
                                    })

                                }
                            </div>
                        </Stack>

                        <Stack spacing={3} sx={this.state.prodotti.length > 0 ? {mt: 2} : {mt: 0}}>
                            <FormControlLabel
                                control={<Android12Switch checked={this.state.gru} onChange={() => {
                                    this.setState({ gru: !this.state.gru });
                                }}
                                />}
                                label="Necessaria gru"
                            />
                            <FormControlLabel
                                control={<Android12Switch sx={{ marginLeft: -0.5 }} checked={this.state.autotreno} onChange={() => {
                                    this.setState({ autotreno: !this.state.autotreno });
                                }}
                                />}
                                label="Passa autotreno"
                            />
                            {/* TECNICO TRUE OR FALSE */}
                            <FormControlLabel
                                control={<Android12Switch checked={this.state.tecnico} sx={{ marginLeft: -0.5 }} onChange={() => this.setState({ tecnico: !this.state.tecnico })} />}
                                label="Richiesto sopralluogo tecnico"
                            />
                            {/* COSTO TECNICO */}
                            {
                                this.state.tecnico && (
                                    <TextField sx={{ mt: 3 }} type="number" variant="outlined" label={'Costo Tecnico'} value={this.state.costoTecnico}
                                        InputProps={{ endAdornment: <InputAdornment position="end">€</InputAdornment>, }}
                                        onChange={(e) => {
                                            let costo = e.target.value;
                                            this.setState(() => ({ costoTecnico: costo }), () => this.calcolaTotale());
                                        }
                                        } />
                                )
                            }

                            {/* TOTALE CON IVA*/}
                            <TextField InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">€ </InputAdornment> }} sx={{ mt: 3 }} variant="outlined" label="Totale con IVA" value={this.state.totale} InputLabelProps={{ shrink: this.state.totale }}
                                onChange={(e) => { this.setState({ totale: e.target.value }) }
                            } />

                            {/* IVA */}
                            <TextField InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">€ </InputAdornment> }} sx={{ mt: 3 }} variant="outlined" label="IVA Totale" value={this.state.totale * 0.22} InputLabelProps={{ shrink: true }} />

                            {/* PREVENTIVO */}
                            <TextField
                                select
                                key={Math.random()}
                                value={this.state.is_preventivo}
                                label="Tipo ordine"
                                onChange={(e) => {
                                    this.setState({ is_preventivo: e.target.value })
                                }}
                            >
                                <MenuItem value={1}>Preventivo</MenuItem>
                                <MenuItem value={0}>Ordine</MenuItem>
                            </TextField>
                        </Stack>

                        {/* FATTURAZIONE E PAGAMENTI */}
                        {
                            !this.state.legato_cliente && (
                                <Stack spacing={3}>
                                    {/* FATTURAZIONE */}
                                    <div style={rowTitle}>
                                        <SettingsTitle title="Regole di fatturazione" />
                                        <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInputPagamenti('fatturazione')} />
                                    </div>
                                    <p style={{ color: this.state.fatPerc !== 100.0 ? 'red' : 'darkgrey', marginTop: -15, marginLeft: 5 }}>{isNaN(this.state.fatPerc) ? 0 : this.state.fatPerc} % coperto</p>

                                    <Stack spacing={1}>
                                        {
                                            this.state.fatturazione.map((el, i) => {
                                                return (
                                                    <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} alignItems='center' key={'fatturazione' + i}>
                                                        {/* Percentuale */}
                                                        <TextField
                                                            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment>, }}
                                                            value={el.percentage}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.fatturazione]
                                                                arr[i] = { ...arr[i], percentage: e.target.value }
                                                                this.setState({ fatturazione: arr }, () => this.updatePercentage())
                                                            }}
                                                        />
                                                        <Typography>a</Typography>
                                                        {/* Giorni */}
                                                        <TextField
                                                            InputProps={{ endAdornment: <InputAdornment position="end">gg</InputAdornment>, }}
                                                            value={el.days}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.fatturazione]
                                                                arr[i] = { ...arr[i], days: e.target.value }
                                                                this.setState({ fatturazione: arr })
                                                            }}
                                                        />
                                                        <Typography>giorni da </Typography>
                                                        {/* DA */}
                                                        <TextField
                                                            select
                                                            value={el.from}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.fatturazione]
                                                                arr[i] = { ...arr[i], from: e.target.value }
                                                                this.setState({ fatturazione: arr })
                                                            }}
                                                        >
                                                            <MenuItem value={'DO'}>DO</MenuItem>
                                                            <MenuItem value={'DC'}>DC</MenuItem>
                                                            <MenuItem value={'DP'}>DP</MenuItem>
                                                        </TextField>
                                                        {/* DELETE FATTURAZIONE ROW */}
                                                        <ManageRowSettings
                                                            callback={() => {
                                                                let updated = this.state.fatturazione.filter((e, index) => index !== i)
                                                                this.setState(() => ({ fatturazione: updated }), () => {
                                                                    this.updatePercentage();
                                                                })
                                                            }}
                                                        />
                                                    </Stack>
                                                )
                                            })
                                        }
                                    </Stack>

                                    {/* INCASSO */}
                                    <div style={rowTitle}>
                                        <SettingsTitle title="Regole di incasso" />
                                        <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInputPagamenti('incasso')} />
                                    </div>
                                    <p style={{ color: this.state.incPerc !== 100.0 ? 'red' : 'darkgrey', marginTop: -15, marginLeft: 5 }}>{isNaN(this.state.incPerc) ? 0 : this.state.incPerc} % coperto</p>

                                    <Stack spacing={1}>
                                        {
                                            this.state.incasso.map((el, i) => {
                                                return (
                                                    <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} key={'incasso' + i} alignItems='center'>
                                                        <TextField
                                                            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment>, }}
                                                            value={el.percentage}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.incasso]
                                                                arr[i] = { ...arr[i], percentage: e.target.value }
                                                                this.setState({ incasso: arr }, () => this.updatePercentage())
                                                            }}
                                                        />
                                                        <Typography>a</Typography>
                                                        <TextField
                                                            InputProps={{ endAdornment: <InputAdornment position="end">gg</InputAdornment>, }}
                                                            value={el.days}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.incasso]
                                                                arr[i] = { ...arr[i], days: e.target.value }
                                                                this.setState({ incasso: arr })
                                                            }}
                                                        />
                                                        <Typography>giorni da </Typography>
                                                        <TextField
                                                            select
                                                            value={el.from}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.incasso]
                                                                arr[i] = { ...arr[i], from: e.target.value }
                                                                this.setState({ incasso: arr })
                                                            }}
                                                        >
                                                            <MenuItem value={'DO'}>DO</MenuItem>
                                                            <MenuItem value={'DC'}>DC</MenuItem>
                                                            <MenuItem value={'DP'}>DP</MenuItem>
                                                        </TextField>
                                                        {/* DELETE INCASSO ROW */}
                                                        <ManageRowSettings
                                                            callback={() => {
                                                                let updated = this.state.incasso.filter((e, index) => index !== i)
                                                                this.setState(() => ({ incasso: updated }), () => {
                                                                    this.updatePercentage();
                                                                })
                                                            }}
                                                        />
                                                    </Stack>
                                                )
                                            })
                                        }
                                    </Stack>

                                    {/* PROVVIGIONI */}
                                    <div style={rowTitle}>
                                        <SettingsTitle title="Regole di provvigioni" />
                                        <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInputPagamenti('provvigioni')} />
                                    </div>

                                    <Stack spacing={1}>
                                        {
                                            this.state.provvigioni.map((el, i) => {
                                                return (
                                                    <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} alignItems='center'>
                                                        <TextField
                                                            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment>, }}
                                                            value={el.percentage}
                                                            onCanPlay={(e) => {
                                                                let arr = [...this.state.provvigioni]
                                                                arr[i] = { ...arr[i], percentage: e.target.value }
                                                                this.setState({ provvigioni: arr })
                                                            }}
                                                        />
                                                        <Typography>a</Typography>
                                                        <TextField
                                                            InputProps={{ endAdornment: <InputAdornment position="end">gg</InputAdornment>, }}
                                                            value={el.days}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.provvigioni]
                                                                arr[i] = { ...arr[i], days: e.target.value }
                                                                this.setState({ provvigioni: arr })
                                                            }}
                                                        />
                                                        <Typography>giorni da </Typography>
                                                        <TextField
                                                            select
                                                            value={el.from}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.provvigioni]
                                                                arr[i] = { ...arr[i], from: e.target.value }
                                                                this.setState({ provvigioni: arr })
                                                            }}
                                                        >
                                                            <MenuItem value={'DO'}>DO</MenuItem>
                                                            <MenuItem value={'DC'}>DC</MenuItem>
                                                            <MenuItem value={'DP'}>DP</MenuItem>
                                                        </TextField>
                                                        {/* DELETE POVVIGIONI ROW */}
                                                        <ManageRowSettings
                                                            callback={() => {
                                                                let updated = this.state.provvigioni.filter((e, index) => index !== i)
                                                                this.setState({ provvigioni: updated })
                                                            }}
                                                        />
                                                    </Stack>
                                                )
                                            })
                                        }
                                    </Stack>

                                    {/* PROVVIGIONI SEGNALATORE */}
                                    <div style={rowTitle}>
                                        <SettingsTitle title="Regole di provvigioni (segnalatore)" />
                                        <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInputPagamenti('provvigioniSegnalatore')} />
                                    </div>

                                    <Stack spacing={1}>
                                        {
                                            this.state.provvigioniSegnalatore.map((el, i) => {
                                                return (
                                                    <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} alignItems='center'>
                                                        <TextField
                                                            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment>, }}
                                                            value={el.percentage}
                                                            onCanPlay={(e) => {
                                                                let arr = [...this.state.provvigioniSegnalatore]
                                                                arr[i] = { ...arr[i], percentage: e.target.value }
                                                                this.setState({ provvigioniSegnalatore: arr })
                                                            }}
                                                        />
                                                        <Typography>a</Typography>
                                                        <TextField
                                                            InputProps={{ endAdornment: <InputAdornment position="end">gg</InputAdornment>, }}
                                                            value={el.days}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.provvigioniSegnalatore]
                                                                arr[i] = { ...arr[i], days: e.target.value }
                                                                this.setState({ provvigioniSegnalatore: arr })
                                                            }}
                                                        />
                                                        <Typography>giorni da </Typography>
                                                        <TextField
                                                            select
                                                            value={el.from}
                                                            onChange={(e) => {
                                                                let arr = [...this.state.provvigioniSegnalatore]
                                                                arr[i] = { ...arr[i], from: e.target.value }
                                                                this.setState({ provvigioniSegnalatore: arr })
                                                            }}
                                                        >
                                                            <MenuItem value={'DO'}>DO</MenuItem>
                                                            <MenuItem value={'DC'}>DC</MenuItem>
                                                            <MenuItem value={'DP'}>DP</MenuItem>
                                                        </TextField>
                                                        {/* DELETE POVVIGIONI SEGNALATORE ROW */}
                                                        <ManageRowSettings
                                                            callback={() => {
                                                                let updated = this.state.provvigioniSegnalatore.filter((e, index) => index !== i)
                                                                this.setState({ provvigioniSegnalatore: updated })
                                                            }}
                                                        />
                                                    </Stack>
                                                )
                                            })
                                        }
                                    </Stack>
                                </Stack>
                            )
                        }

                        <div style={{ height: 30 }}></div>
                        <LoadingButton fullWidth sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.save()}>Salva</LoadingButton>
                    </>
                )}
            </>
        );
    }

    async save() {

        if (!this.state.cliente) {
            alert('Inserire un cliente valido');
            return;
        }

        if (!this.state.descrizione) {
            alert('Inserire una descrizione valida');
            return;
        }

        if (this.state.prodotti.length === 0) {
            alert('Inserire un prodotto');
            return;
        }

        if (this.state.tecnico && !this.state.costoTecnico) {
            alert('Inserire un costo per assistenza tecnica valida');
            return;
        }

        if (!this.state.totale) {
            alert('Inserire un totale valido');
            return;
        }

        const nome_cliente = this.state.clienti.find(c => c.id == this.state.cliente).ragione_sociale;

        // CONTROLLO SELEZIONE AGENTE E SEGNALATORE SENZA PROVVIGIONI
        if ((this.state.agente !== '' && this.state.agente !== 'Nessun agente') && this.state.provvigioni.length < 1) {
            alert(`Il cliente ${nome_cliente} non ha regole di provvigione per l'agente`);
            return;
        }
        
        if ((this.state.segnalatore !== '' && this.state.segnalatore !== 'Nessun segnalatore') && this.state.provvigioniSegnalatore.length < 1) {
            alert(`Il cliente ${nome_cliente} non ha regole di provvigione per il segnalatore`);
            return;
        }

        // CONTROLLO SE CI SONO CAMPI VUOTI
        let percs = this.state.fatturazione.filter(e => e.percentage === '' || e.days === '' || e.from === '');
        if (percs.length > 0) {
            alert('Ci sono alcuni campi incompleti nelle regole di fatturazione.');
            return;
        }

        let incs = this.state.incasso.filter(e => e.percentage === '' || e.days === '' || e.from === '');
        if (incs.length > 0) {
            alert('Ci sono alcuni campi incompleti nelle regole di incasso.');
            return;
        }

        let provv = this.state.provvigioni.filter(e => e.percentage === '' || e.days === '' || e.from === '');
        if (provv.length > 0) {
            alert('Ci sono alcuni campi incompleti nelle regole delle provvigioni.');
            return;
        }

        let provvv = this.state.provvigioniSegnalatore.filter(e => e.percentage === '' || e.days === '' || e.from === '');
        if (provvv.length > 0) {
            alert('Ci sono alcuni campi incompleti nelle regole delle provvigioni per i segnalatori.');
            return;
        }

        //CONTROLLO PERCENTUALI
        if (!this.state.legato_cliente) {
            if (this.state.fatPerc !== 100) {
                alert('La somma delle percentuali di fatturazione deve essere 100%');
                return;
            }
            if (this.state.incPerc !== 100) {
                alert('La somma delle percentuali di incasso deve essere 100%');
                return;
            }
        }

        //GENERAZIONE STRINGA AGENTI
        let agentiString = ''
        if (this.state.agente !== '' || this.state.agente !== 'Nessun agente') {
            agentiString = this.state.agente + ';'
        }
        if (this.state.segnalatore !== '' || this.state.segnalatore !== 'Nessun segnalatore') {
            agentiString += this.state.segnalatore + ';'
        }

        let consegna_max = 0;
        this.state.prodotti.forEach(prodotto => {
            let prodottoConsegna = parseInt(this.state.prodottiList.find((n) => n.id === prodotto.id_prodotto).consegna_max);

            if (prodottoConsegna >= consegna_max) {
                consegna_max = prodottoConsegna;
            }
        });

        let data_ideale = moment().add(consegna_max, 'days').format('DD/MM/YYYY');

        this.setState({ isLoading: true });

        let ordine = {
            cliente: this.state.cliente,
            descrizione: this.state.descrizione,
            prodotti: this.state.prodotti,
            tecnico: this.state.tecnico === true ? '1' : '0',
            costoTecnico: this.state.costoTecnico || 0,
            is_preventivo: this.state.is_preventivo,
            totale: this.state.totale,
            id_agente: agentiString,
            id_funzionario: this.state.funzionario,
            legato_cliente: this.state.legato_cliente ? 1 : 0,
            fatturazione: this.state.fatturazione,
            pagamento: this.state.incasso,
            provvigioni: this.state.provvigioni,
            segnalatore: this.state.provvigioniSegnalatore,
            cantiere: this.state.riferimento_cantiere,
            consegna_max: data_ideale,
            gru: this.state.gru ? 1 : 0,
            autotreno: this.state.autotreno ? 1 : 0,
            indirizzo: this.state.indirizzo,
            rif: this.state.rif
        };

        let res = await addOrdine(username, token, ordine);

        if (res.result === 'ok') {
            addReminder(username, token, `Aggiunto nuovo ${this.state.is_preventivo ? 'preventivo' : 'ordine'} ` + res.ordine.rif, 'amministrazione', 'ordine', res.ordine.id);
            window.location.href = this.state.is_preventivo === 0 ? '/#/commerciale/ordini' : '/#/commerciale/preventivi';
            return
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la creazione dell\'ordine. Per favore, riprova.');
    }

}

const selectionButton = {
    height: 30,
    width: 140,
    marginLeft: 5,
    borderTopLeftRadius: 15,
    borderBottomLeftRadius: 15,
    textAlign: 'center',
    paddingTop: 4,
    cursor: 'pointer'
}

const rightSelectionButton = {
    height: 30,
    width: 140,
    marginLeft: 5,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    textAlign: 'center',
    paddingTop: 4,
    cursor: 'pointer'
}

